//import ZeroWaste from './ZeroWaste'
import BladderCancer from './BladderCancer'
import AmznRatings from './PredictingAmazonRatings'
import ZW from './ZeroWaste.js'
export default [new AmznRatings(), new BladderCancer(), new ZW()]



// WEBPACK FOOTER //
// ./src/components/projects/active/index.js